<template>
  <default-layout>
    <div class="container flex flex-col items-center py-12">
      <slot></slot>
    </div>
  </default-layout>
</template>

<script setup lang="ts">
import DefaultLayout from './default.vue'
</script>
